import React from "react";
import { useNavigate } from "react-router-dom";
import "./Navbar.css";
import ThemeButton from "../ui/ThemeButton";

const Navbar = (props) => {
  const navigate = useNavigate();

  const routeTo = () => navigate("/");

  return (
    <nav className="Navbar">
      <div onClick={routeTo} id="logo" className="logo fg fg1 animate-enlarge">
        Enties
      </div>
      <div className="nav-menu-group">
        {/* <ThemeButton className="nav-menu" /> */}
        <div className="nav-menu animate-enlarge">
          <h3>Pricing</h3>
        </div>
        <div className="nav-menu animate-enlarge">
          <h3>Login</h3>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
